module.exports = __webpack_public_path__ + "img/bruno.0e2cf707.png";